
import { getHostname } from 'bits/url'
import { Component, Prop, Vue, Watch } from 'bits/vue'
import { AudioSearchResult, SearchFilters, VideoSearchResult } from 'bits/web_search'
import FallbackAudio from 'images/fallback_audio.png' // 1440x1440
import ImageThumbnail from 'library/v4/components/ImageThumbnail.vue'
import BaseIcon from 'vuecomponents/base_icon.vue'

@Component({ components: { BaseIcon, ImageThumbnail } })
export default class ContentPickerSearchResultsAv extends Vue {
  $refs!: { container: HTMLUListElement; imageWrappers: HTMLDivElement[] }
  imageWidth = 0
  SearchFilters = SearchFilters
  @Prop() results!: (AudioSearchResult | VideoSearchResult)[]
  @Prop() filter!: SearchFilters
  LOADING_IMAGES_BG_COLOR = ['red', 'blue', 'green', 'yellow', 'purple', 'pink', 'cyan', 'orange']
  CROP_ASPECT_RATIO = 1.8 /* 16.2:9 to remove borders nicely since 16/9=1.(7) is non-terminating */
  FallbackAudio = FallbackAudio
  @Watch('results')
  handleResultsUpdate(): void {
    this.$nextTick(() => {
      this.imageWidth =
        this.$refs.imageWrappers && this.$refs.imageWrappers[0] && this.$refs.imageWrappers[0].clientWidth
    })
  }
  select(url: string): void {
    this.$emit('select', url)
  }

  audioDescription(result: AudioSearchResult): string {
    if (result.release_date) {
      // podcast episode
      const showName = result.show_name
      if (showName) {
        return showName + ' · ' + new Date(result.release_date).toLocaleDateString()
      }
      let shortenedDescription = result.description.split(' ').slice(0, 15).join(' ')
      if (shortenedDescription.length < result.description.length) {
        shortenedDescription = shortenedDescription + '...'
      }
      return new Date(result.release_date).toLocaleDateString() + ' · ' + shortenedDescription
    }
    return result.description
  }

  providerName(result: VideoSearchResult): string {
    if (result.provider_name) return result.provider_name
    return getHostname(result.url)
  }

  isUsingFallbackThumbnail(result: AudioSearchResult): boolean {
    return !result.thumbnail_url || result.thumbnail_url === ''
  }

  mounted(): void {
    this.imageWidth = this.$refs.container.clientWidth / 3 - 12
    this.$nextTick(() => {
      this.imageWidth =
        this.$refs.imageWrappers && this.$refs.imageWrappers[0] && this.$refs.imageWrappers[0].clientWidth
    })
  }
}
